export enum UserOrigin {
  HOST = 'HOST',
  RENTER = 'RENTER',
}
